module.exports = __webpack_public_path__ + "img/atendimentos-domiciliares.a0da9647.svg";